import React from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import eclosBrandLogo from '../../../assets/img/logos/brands/logo-eclos-brand-white.svg'
import mainBackgroundImage from '../../../assets/img/banner-eclos-brand/eclos-brand-background-1.png'
import homeImg from '../../../assets/img/banner-eclos-brand/eclos-brand-home-img.png'
import catalogImgBanner from '../../../assets/img/banner-eclos-brand/eclos-brand-catalog-img.png'
import catalogMiniGridImgBanner from '../../../assets/img/banner-eclos-brand/eclos-brand-mini-grid.png'
import catalogBgImage from '../../../assets/img/banner-eclos-brand/eclos-brand-catalog-bg.png'
import { changeCenter } from '../../../store/centers/actions'
import { fetchProductsDiscounts } from '../../../store/products/actions'
import { getLocalizedUrl } from '../../../store/ui/reducers'

import Translation from '../../global/Translation'
import LocalizedLink from '../../global/LocalizedLink'
import { FormattedHTMLMessage } from 'react-intl'
import Button from '../../global/Button'
import { getSelectedCenter } from '../../../store/centers/reducers'

const mapStateToProps = state => {
    return {
        localizedUrl: (intl, routeId, params = {}) => getLocalizedUrl(state, intl, routeId, params),
        selectedCenter: getSelectedCenter(state)
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onChangeCenter: (centerId, urlCallback) => {
            dispatch({ type: 'CHANGE_CENTER_BY_USER', center: centerId })
            dispatch(changeCenter(centerId, urlCallback))
            dispatch({ type: 'REMEMBERED_CENTER' })
            dispatch(fetchProductsDiscounts())
        }
    }
}

class BannerEclosBrand extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            isMobile: window.innerWidth < 768
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize)
    }

    handleResize = () => {
        this.setState({ isMobile: window.innerWidth < 768 })
    }

    render() {
        const { isHomeSlideView, isPriaorityCustomer, className } = this.props
        const { isMobile } = this.state

        const homeImgBlock = (
            <div className="img-block">
                <div>
                    <img src={homeImg} alt="Colors collection" />
                </div>
            </div>
        )

        const catalogPriorityImgBlock = (
            <div className="img-block">
                <div>
                    <img src={catalogImgBanner} alt="Colors collection" />
                </div>
            </div>
        )

        const secondHeadingBlock = (
            <div className="second-heading-block">
                <FormattedHTMLMessage id="inlayer_full_body_design_tech" defaultMessage="Inlayer <b>full body</b> design tech" />
                <FormattedHTMLMessage id="superior_heat_resistance" defaultMessage="<b>Superior heat</b> resistance" />
                <FormattedHTMLMessage id="zero_silica" defaultMessage="<b>Zero</b> silica" />
            </div>
        )

        /* const btnPriorityBlock = (
            <div className="btn-custom-block">
                <LocalizedLink routeId="ROUTE_CATALOG" queryString="?type[0]=SLAB&brand[0]=ECLOS" params={{ outlet: '' }}>
                    <Button inverted>
                        <Translation id="discover_eclos" defaultMessage="Discover ÉCLOS" />
                    </Button>
                </LocalizedLink>
            </div>
        ) */

        const btnPriorityBlock = (
            <div className="btn-custom-block">
                {this.props.selectedCenter == 1100 ? (
                    <LocalizedLink routeId="ROUTE_CATALOG" queryString="?type[0]=SLAB&brand[0]=ECLOS" params={{ outlet: '' }}>
                        <Button inverted>
                            <Translation id="discover_eclos" defaultMessage="Discover ÉCLOS" />
                        </Button>
                    </LocalizedLink>
                ) : (
                    <Button
                        inverted
                        onClick={() => {
                            let baseUrl = this.props.localizedUrl(this.props.intl, 'ROUTE_CATALOG', { outlet: '' })
                            baseUrl = baseUrl.replace(/\?+$/, '')
                            const queryString = '?type[0]=SLAB&brand[0]=ECLOS'

                            this.props.onChangeCenter(1100, `${baseUrl}${queryString}`)
                        }}
                    >
                        <Translation id="discover_eclos" defaultMessage="Discover ÉCLOS" />
                    </Button>
                )}
            </div>
        )

        const btnNonPriorityBlock = (
            <div className="non-priority-block">
                <div className="get-ready">
                    <span>
                        <Translation id="get_ready_for_eclos" defaultMessage="Get ready for ÉCLOS" />
                    </span>
                </div>
                <div className="collide">
                    <span>
                        <Translation id="where_design_and_innovation_collide" defaultMessage="where design and innovation collide." />
                    </span>
                </div>
                <div className="coming-soon">
                    <span>
                        <Translation id="coming_soon" defaultMessage="Coming soon" />
                    </span>
                </div>
            </div>
        )

        const mainHeadingBlock = (
            <div className="main-heading-block">
                <h2>
                    <Translation id="the_next_generation_of_mineral_surface" defaultMessage="the next generation of mineral surface" />
                </h2>
            </div>
        )

        const brandBlock = (
            <div className="brand-block">
                <img src={eclosBrandLogo} alt="Éclos Brand" />
            </div>
        )

        const exclusiveColorsBlock = (
            <div className="exclusive-colors">
                <span>
                    <Translation id="exclusive_colors" defaultMessage="Exclusive colors" />
                </span>
            </div>
        )

        const mobileDiscoverEclosBlock = (
            <div className="mobile-discover-block">
                <div>
                    <img src={catalogMiniGridImgBanner} alt="Discover ÉCLOS" />
                </div>
                <div>{btnPriorityBlock}</div>
            </div>
        )

        const conditionsBlock = (
            <div className="eclos-conditions-block">
                <span>
                    <Translation id="the_purchase_of_eclos_materials_is_subject_to_conditions" defaultMessage="The purchase of ÉCLOS materials is subject to conditions." />
                </span>
            </div>
        )

        return (
            <React.Fragment>
                {isPriaorityCustomer ? (
                    <React.Fragment>
                        {isHomeSlideView ? (
                            <div
                                className="banner__eclos"
                                style={{
                                    backgroundImage: `url(${mainBackgroundImage})`,
                                    backgroundRepeat: 'no-repeat',
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'right',
                                    height: '100%',
                                    width: '100%'
                                }}
                            >
                                <div className="home-main-content">
                                    <div className="left-block">
                                        {exclusiveColorsBlock}
                                        {brandBlock}
                                        {mainHeadingBlock}
                                        {secondHeadingBlock}
                                        {conditionsBlock}
                                        {!isMobile && btnPriorityBlock}
                                    </div>
                                    <div className="right-block">{isMobile ? mobileDiscoverEclosBlock : homeImgBlock}</div>
                                </div>
                            </div>
                        ) : (
                            <div
                                className="banner__eclos"
                                style={{
                                    backgroundImage: `url(${catalogBgImage})`,
                                    backgroundRepeat: 'no-repeat',
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center center',
                                    height: '100%',
                                    width: '100%'
                                }}
                            >
                                <div className={`catalog-main-content ${!isPriaorityCustomer ? 'is-no-priority' : ''} ${className}`}>
                                    <div className="left-block">
                                        {brandBlock}
                                        {mainHeadingBlock}
                                        {!(isMobile && !isPriaorityCustomer) && secondHeadingBlock}
                                    </div>
                                    {isPriaorityCustomer ? (
                                        <div className="right-block">
                                            <div className="exclusive-colors-block">{exclusiveColorsBlock}</div>

                                            {!isMobile ? (
                                                <div className="catalog-img-banner">
                                                    {catalogPriorityImgBlock}
                                                    {btnPriorityBlock}
                                                </div>
                                            ) : (
                                                <div style={{ width: '100%' }}>{mobileDiscoverEclosBlock}</div>
                                            )}
                                        </div>
                                    ) : (
                                        <div className="right-block">{btnNonPriorityBlock}</div>
                                    )}
                                </div>
                            </div>
                        )}
                    </React.Fragment>
                ) : null}
            </React.Fragment>
        )
    }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(BannerEclosBrand))
